import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=b8469d34&"
import script from "./AboutModal.vue?vue&type=script&lang=ts&"
export * from "./AboutModal.vue?vue&type=script&lang=ts&"
import style0 from "./AboutModal.vue?vue&type=style&index=0&id=b8469d34&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports